import React from "react";
 
import Container from "react-bootstrap/Container";
import Usuario from "../components/Perfil/Usuario";
import AlterarSenha from "../components/Perfil/AlterarSenha";

const Perfil = () => { 
	return (
		<>
			<Container>
				<h1 className="m-5">Perfil</h1>

				<Usuario />
				<AlterarSenha />
			</Container>
		</>
	);
};

export default Perfil;
